import type { FaireProductEntity } from "../../entity_types/product";

export const p_vgejvkavgb: FaireProductEntity = {
  token: "p_vgejvkavgb",
  type: "product",
  name: "Winston Socks",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c91026a8d9a81112084d72ad498621ddf07a8fc86773465024b4ddf41dec5bc2.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/cbcb65778b04ec245802085af7d174c1ef91535b6b3ee9fc749914f324dfb072.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
